import { render, staticRenderFns } from "./PetAndProjectComponent.vue?vue&type=template&id=b3d6beaa&scoped=true&"
import script from "./PetAndProjectComponent.vue?vue&type=script&lang=js&"
export * from "./PetAndProjectComponent.vue?vue&type=script&lang=js&"
import style0 from "./PetAndProjectComponent.vue?vue&type=style&index=0&id=b3d6beaa&lang=scss&scoped=true&"
import style1 from "./PetAndProjectComponent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d6beaa",
  null
  
)

export default component.exports